import React from 'react';

import { TipPage } from 'components/tip-page';

export const PhysicalLimitationsTip = () => {

    return (
        <TipPage
            imgSrc='svg/reinforcement-icons/bones.svg'
            text={{
                description: 'physical-limitations-tip-title',
                next: 'physical-limitations-tip-button-next'
            }}
        />
    );
};
